import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
    FONT_SIZE_XS,
    BUTTON_FONT_FAMILY,
    BUTTON_FONT_WEIGHT,
    BUTTON_LETTER_SPACING,
} from "../../../style/fontSettings";
import {
    MELOGY_WHITE,
    MELOGY_TRANSPARENT,
    SECONDARY,
} from "../../../style/colors";
import { showToastError } from "../../../style/ShowToast";

const SongNameContainer = styled.div`
    height: 64px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
`;

const SongNameBackground = styled.div`
    color: ${SECONDARY};
    background-color: transparent;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const SongNameInput = styled.input`
    font-family: ${BUTTON_FONT_FAMILY};
    font-weight: ${BUTTON_FONT_WEIGHT};
    letter-spacing: ${BUTTON_LETTER_SPACING};
    font-size: ${FONT_SIZE_XS};
    height: 32px;
    width: 100%;
    color: ${MELOGY_WHITE};
    background-color: transparent;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    border: none;
    border-radius: 0;
    text-align: center;
    padding: 0 8px;

    &:focus {
        outline: none;
    }
`;

const SongName = ({
    selectedSong,
    color,
    setSongName,
    isNameUnique,
}) => {
    const originalSongName = selectedSong?.name || "";
    const [tempName, setTempName] = useState(originalSongName);

    useEffect(() => {
        setTempName(selectedSong?.name || "");
    }, [selectedSong]);

    const validateAndSetSongName = () => {
        // Skip validation if the name hasn't changed
        if (tempName === originalSongName) {
            return;
        }

        // Validate characters
        const regex = /^[a-zA-Z0-9.\-_, !?]+$/;
        if (!regex.test(tempName)) {
            showToastError("Invalid characters in the song name", 5000);
            setTempName(originalSongName);
            return;
        }

        // Validate length
        if (tempName.length > 42) {
            showToastError("Song name should be at most 42 characters", 5000);
            setTempName(originalSongName);
            return;
        }

        // Validate uniqueness
        if (!isNameUnique(tempName)) {
            showToastError("Song name should be unique", 5000);
            setTempName(originalSongName);
            return;
        }

        // Update the song name if all validations pass
        setSongName(tempName);
    };

    return (
        <SongNameContainer>
            <SongNameBackground>
                <SongNameInput
                    value={tempName}
                    onChange={(e) => setTempName(e.target.value)}
                    onBlur={validateAndSetSongName}
                    style={{ color }} 
                    spellCheck={false}
                />
            </SongNameBackground>
        </SongNameContainer>
    );
};

export default SongName;

